import { render } from "./Audio.vue?vue&type=template&id=1e18886e&lang=pug"
import script from "./Audio.vue?vue&type=script&setup=true&lang=js"
export * from "./Audio.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__